import { Tooltip, cn } from '@/design-system';

export interface BankIdentityProps {
  code: string;
  name?: string;
  variant?: 'code' | 'name' | 'both';
  className?: string;
}

/** Banks are plain text: short code in tables (full name on hover), full name in headers. */
export function BankIdentity({ code, name, variant = 'code', className }: BankIdentityProps) {
  if (variant === 'name') return <span className={className}>{name ?? code}</span>;
  if (variant === 'both')
    return (
      <span className={cn('inline-flex items-baseline gap-1.5', className)}>
        <span className="font-medium">{code}</span>
        {name && name !== code ? <span className="text-ink-secondary">{name}</span> : null}
      </span>
    );
  return (
    <Tooltip content={name && name !== code ? name : undefined}>
      <span className={cn('font-medium', className)}>{code}</span>
    </Tooltip>
  );
}
